module.exports = __webpack_public_path__ + "static/media/hide.f8e926ba.svg";